import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { DeviceModels } from '../../config';
import { history } from '../../history';
import { InstallationAction, RayCodeAction, ProductAction } from '../../actions';
import { RayForm, RayFormValidation } from '../common';
import { useTranslation } from 'react-i18next';
import { Html5Qrcode, Html5QrcodeScannerState } from 'html5-qrcode';
import { Translate as t } from '../../config/Translate';

// BUG fix: react-qr-reader@2.2.1 은 Android 다중 후면 카메라에서 디코드 실패 → html5-qrcode 로 교체.
const INST_QR_REGION_ID = 'inst-qr-reader-region';

const InstallationStep0 = ({ newInst, info, Create, Update, GetProduct, codelist, product, isSummary = false, gostep }) => {
	// const [ t, i18n ] = useTranslation();
	const [errors, setErrors] = useState([]);
	const [searchErr, setSearchErr] = useState("");
	const [snStart, setSNSatart] = useState(false);
	const [searchSN, setSearchSN] = useState("");
	const [qrStart, setQRStart] = useState(false);
	const [err, setErr] = useState("");
	const isCameraSupported = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
	const scannerRef = useRef(null);
	const [isAddProcess, setIsAddProcess] = useState(false);
	const [installation, setInstallation] = useState(info);
	const [options, setOptions] = useState([]);
	const [allCodeList, setAllCodeList] = useState([]);

	useEffect(() => {
		if(codelist?.length > 0){
			setAllCodeList(codelist.filter(x => x.type === 'PRODUCTOPTION'));
		}
		// RayCodeAction.GetAllByFilter({ type: "PRODUCTOPTION" }).then(x => {
		// 	setAllCodeList([...x]);
		// });
	}, [codelist]);

	useEffect(() => {
		if (isAddProcess) {
			history.push("/Installation/" + newInst._id);
		}
	}, [newInst]);

	useEffect(() => {
		if (info._id) {
			setInstallation({ ...info });
			setSNSatart(true);
		}
	}, [info]);

	useEffect(() => {
		if (product) {
			setProduct(product);
			getOptions(product.model);
		}
	}, [product]);

	const setProduct = (product) => {
		if (product.sn) {
			setInstallation({
				...installation,
				sn: product.sn,
				siteId: product.siteId,
				model: product.model,
				option: product.codes
			});
			setSNSatart(true);
		}
	}

	const handleScan = data => {
		if (!data) return;
		const arr = data.split('=');
		// 'prefix=SN' 형식이면 SN, 아니면 원문 사용
		const sn = (arr.length > 1 ? arr[1] : arr[0]).trim();
		if (sn) {
			SearchStart(sn);
		}
	}

	const stopScanner = () => {
		const scanner = scannerRef.current;
		scannerRef.current = null;
		if (scanner && scanner.getState && scanner.getState() === Html5QrcodeScannerState.SCANNING) {
			scanner.stop().then(() => scanner.clear()).catch(() => { });
		}
	}

	useEffect(() => {
		if (!qrStart || !isCameraSupported) {
			return undefined;
		}
		setErr("");
		const scanner = new Html5Qrcode(INST_QR_REGION_ID);
		scannerRef.current = scanner;
		let handled = false;
		let cancelled = false;
		scanner.start(
			{ facingMode: "environment" },
			{ fps: 10, qrbox: { width: 250, height: 250 } },
			(decodedText) => {
				if (handled) return;
				handled = true;
				handleScan(decodedText);
				stopScanner();
				setQRStart(false);
			},
			() => { /* 프레임별 디코드 미스: 정상, 무시 */ }
		).then(() => {
			// start() resolve 전 cleanup 이 실행된 경우(race):
			// cleanup 이 scannerRef.current=null 로 비웠으므로 stopScanner() 는 no-op.
			// 클로저 scanner 를 직접 참조하여 SCANNING 상태면 자원 해제.
			if (cancelled && scanner.getState && scanner.getState() === Html5QrcodeScannerState.SCANNING) {
				scanner.stop().then(() => scanner.clear()).catch(() => {});
			}
		}).catch((e) => {
			// 카메라 시작 실패 — silent-drop 금지
			console.warn('[InstallationStep0] camera start failed', { handler: 'InstallationStep0', reason: (e && e.message) || String(e) });
			setErr(t('scan.camera.startFailed'));
		});
		return () => {
			cancelled = true;
			stopScanner();
		};
	}, [qrStart, isCameraSupported]);

	const SearchStart = (sn) => {
		ProductAction.GetProductLocal(sn.toUpperCase()).then(x => {
			if (x) {
				setProduct(x);
				getOptions(x.model);
			} else {
				setSearchErr("No records")
			}
		});
	}

	const onKeyPress = (e) => {
		if (e.key == 'Enter') {
			SearchStart(searchSN);
		}
	}

	const getOptions = (model) => {
		const lst = [];
		allCodeList.map(x => {
			if (x.group == model)
				lst.push({ code: x.code, title: x.name });
		});
		if (lst.length > 0) {
			setOptions([...lst]);
		}
	}

	const handleChangeData = (e) => {
		const { name, value } = e.target;
		if (name == "model") {
			getOptions(value);
		}

		// datetime update popup 구현		
		if (name == "option") {
			const matched = codelist.filter(x => x.type === 'PRODUCTOPTION' && x.code === value);
			if (matched.length > 0) {
				setInstallation({ ...installation, optionName: matched[0].name, [name]: value });
			}
		}

		setInstallation({ ...installation, [name]: value });
	};

	const form_controls = [
		{
			title: t('product.label.productInfo'), items: [
				{
					type: "input", name: "sn", label: t('product.field.sn'),
					extra: product,
					val: installation.sn, isEditable: false
				},
				{ type: "select", name: "model", label: t('product.field.model'), val: installation.model, list: DeviceModels, isEditable: false, required: true },
				{ type: "select2", name: "option", label: t('common.label.option'), val: installation.option, list: options, isEditable: true, required: true },
			]
		},
		{
			title: t('installation.label.installDetails'), items: [
				{ type: "datetime", name: "installationDate", label: t('installation.field.installDate'), onlyDate: true, val: installation.installationDate, isEditable: !isSummary },
				{ type: "input", name: "installerName", label: t('installation.field.installer'), val: installation.installerName, isEditable: !isSummary },
			]
		},
	];

	const validNext = (targetStep = 2) => {
		const errValidate = RayFormValidation(form_controls, installation);
		if (errValidate.length > 0) {
			setErrors(errValidate);
		} else {
			setIsAddProcess(true);
			if (installation._id) {
				Update(installation._id, { ...installation, installationStep: targetStep });
			} else {
				Create({ ...installation, installationStep: 2 });
			}
		}
	};

	// 상단 배지·◀▶ 이동: 이 단계 검증을 통과하면 현재 입력과 함께 목표 단계로 저장, 실패하면 오류만 표시.
	useEffect(() => {
		if (gostep && gostep.curStep == 1) {
			if (!installation._id) {
				// 아직 생성 전이라 저장할 대상이 없다 — '다음' 으로 먼저 생성해야 한다.
				console.warn('[InstallationStep0] step jump ignored before creation', { handler: 'InstallationStep0', target: installation.sn, reason: 'installation not created yet', goStepNo: gostep.goStepNo });
				return;
			}
			validNext(gostep.goStepNo);
		}
	}, [gostep]);

	return (
		<>
			{!snStart &&
				<div className="card mb-2">
					<div className="card-body">
						{qrStart &&
							<>
								{isCameraSupported ? (
									<div id={INST_QR_REGION_ID} style={{ width: '100%' }} />
								) : (
									<div className="alert alert-warning">{t('scan.camera.notSupported')}</div>
								)}
								{err && <p className="alert alert-danger">{err}</p>}
								<button className="btn btn-lg btn-outline-primary mb-2 btn-block" onClick={() => setQRStart(false)}>{t('common.button.cancel')}</button>
							</>
						}
						<div className="mt-2">
							<input type="input" name="searchSN" className="form-control" onChange={(e) => { setSearchSN(e.target.value); setSearchErr("") }} value={searchSN}
								placeholder={t('product.message.info.enterValidSerialNumber')}
								onKeyPress={(e) => onKeyPress(e)}
							/>
							{searchErr && <div className="alert alert-danger mt-1">{searchErr}</div>}
							<button className="btn btn-lg btn-primary btn-block" onClick={() => SearchStart(searchSN)}>{t('common.button.search')}</button>
						</div>
						{!qrStart && <button className="btn btn-lg btn-primary btn-block" onClick={() => setQRStart(true)}>{t('scan.button.qrScan')}</button>}
					</div>
				</div>
			}
			{snStart &&
				<>
					<RayForm controls={form_controls} isSummary={isSummary} handleChangeData={handleChangeData} errors={errors} />
					{!isSummary &&
						<div className="section mt-1 mb-2">
							<button className="btn btn-primary btn-block btn-lg" onClick={() => validNext()}>{t('common.button.next')}</button>
							<button className="btn btn-dark btn-block btn-lg mt-1" onClick={() => setSNSatart(false)}>{t('common.button.cancel')}</button>
						</div>
					}
				</>
			}
		</>
	);
};

const mapState = (state) => {
	const newInst = state.InstallationReducer.installation;
	const codelist = state.RayCodeReducer.items;
	return { newInst, codelist };
}

const mapDispatch = (dispatch) => ({
	Create: (data) => dispatch(InstallationAction.CreateInstallation(data)),
	Update: (_id, data) => dispatch(InstallationAction.UpdateInstallation(_id, data)),
});

export default connect(mapState, mapDispatch)(InstallationStep0);